export function scrollToMarketingHash(hash: string, behavior: ScrollBehavior = 'smooth') {
  const id = hash.replace(/^#/, '');
  if (!id) return;
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior, block: 'start' });
  }
}

export function normalizeLandingPath(pathname: string) {
  return pathname.replace(/\/$/, '') || '/';
}

export function isLandingPath(pathname: string) {
  return normalizeLandingPath(pathname) === '/landing';
}
